import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Send train
 * */
export function* sendTrain(data) {
    const response = yield call(api.sendTrain, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.SEND_TRAIN.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `train sent`,
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: `Something wrong `,
            level: 'error',
            _id: Math.random(),
            autoDismiss: 99999,
        },
    });

    yield put({
        type: actionTypes.SEND_TRAIN.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchSendTrain() {
    while (true) {
        const { data } = yield take(actionTypes.SEND_TRAIN.REQUEST);
        yield fork(sendTrain, data);
    }
}

export default [
    watchSendTrain,
];



// WEBPACK FOOTER //
// ./app/sagas/train.js